import { createFileRoute } from "@tanstack/react-router";
import { ProductFormContainer } from "@/features/products/layouts";

export const Route = createFileRoute("/$store/_layout/products_/add")({
	component: AddProductPage,
	validateSearch: (search: Record<string, unknown>) => {
		return {
			edit: (search.edit as string | undefined) || undefined,
		};
	},
});

function AddProductPage() {
	const { store } = Route.useParams();
	const { edit } = Route.useSearch();

	return <ProductFormContainer store={store} productId={edit} />;
}
